require("../../scss/app-registration.scss");

import Application from "./application";
import AddressLookup from "../jsx/address-lookup/address-lookup";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import TogglePasswordBehavior from "../behaviours/toggle-password-field";
import UrlParameterHandlerBehaviour from "../behaviours/url-parameter-handler-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";



let config = {};
config.behaviours = {
    "BackgroundImage": new BackgroundImageBehaviour(),
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    "TogglePasswordBehavior": new TogglePasswordBehavior(),
    "UrlParameterHandlerBehaviour": new UrlParameterHandlerBehaviour(),
    "BlockEventBehaviour": new BlockEventBehaviour()
};
config.components = {
    "shortlist-count": ShortlistCount,
    "address-lookup": AddressLookup,
}

new Application(config);
